
import React, { useEffect, useState } from "react";
import { MdErrorOutline } from "react-icons/md";
import { useToast } from "../../controls/Toast/ToastService";
import Container from "../../base/Container";
import Card from "../../controls/Card";
import { GetAllByUser, GetAllByUserPublic } from "../../../configurations/crud/opdCentersCrud";
import LoadingContainer from "../../controls/LoadingContainer";
import { EBoolBg, GetEBoolName } from "../../../configurations/enums/EBool";
import StatusContainer from "../../controls/StatusContainer";
import { EApplicationUserStatusBg, GetEApplicationUserStatusName } from "../../../configurations/enums/EApplicationUserStatus";
import { GetEGenderName } from "../../../configurations/enums/EGender";
import { BASE_URL, FEMALE_DR_AVATAR, MALE_DR_AVATAR } from "../../../configurations/initUrls";
import { CiLocationArrow1 } from "react-icons/ci";
import { EDoctorStatusBg, GetEDoctorStatusName } from "../../../configurations/enums/EDoctorStatus";
import User from "../users/User";
import moment from 'moment'
import { GetEOpdDaysName } from "../../../configurations/enums/EOpdDays";
import { FaUserEdit } from "react-icons/fa";
import { RiEditBoxFill } from "react-icons/ri";
import { Link, useNavigate, useParams } from "react-router-dom";
import AddOpdOffline from "../opdlive/AddOpdOffline";
import * as opdRegisteredCrud from '../../../configurations/crud/opdRegisteredCrud'
import { IoCheckmarkDoneCircleOutline } from "react-icons/io5";
import { IoMdAdd } from "react-icons/io";
import AddOpdOnline from "../opdlive/AddOpdOnline";
import MasterPage from "../MasterPage";
import useGlobalLoader from "../../../configurations/useGlobalLoader";

export default function CenterAllByUserPublic() {
  const TODAYS_DATE = new Date()
  const { start, end } = useGlobalLoader()
  const [opdCenters, setOpdCenter] = useState([]);
  const [selectedCenter, setSelectedCenter] = useState();
  const [user, setUser] = useState();
  const [loding, setLoding] = useState(false);
  const [lodingCrud, setLodingCrud] = useState(false)
  const [isOpenAdd, setIsOpenAdd] = useState(false)
  const [centerId, setCenterId] = useState()
  const [centerName, setCenterName] = useState()
  const toast = useToast();
  const { doctorId } = useParams()
  const navigate = useNavigate()

  useEffect(() => {
    getAllOpdCenters()
  }, []);

  function getAllOpdCenters() {
    setLoding(true);
    start()
    GetAllByUserPublic({ DoctorId: doctorId })
      .then((res) => {
        let mdata = res.data;
        if (mdata.result.succeeded) {
          if (mdata.data.length > 0)
            setUser(mdata.data[0].user)
          setOpdCenter(mdata.data);
        } else {
          setOpdCenter([]);
          toast.open(mdata.result.message, <MdErrorOutline />, "danger");
        }
        setLoding(false);
        end()
      })
      .catch((errors) => {
        setOpdCenter([]);
        setLoding(false);
        end()
        toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
      });
  }

  const addOpdOnline = (param, setValues) => {
    setLodingCrud(true)
    start()
    opdRegisteredCrud.AddOnline(param).then(res => {
      let mdata = res.data
      if (mdata.result.succeeded) {
        setValues({
          opdCenterId: centerId,
          patientName: "",
          mobile: "",
          bloodGroup: "",
          bloodPressure: "",
          weight: "",
          age: "",
          gender: 0,
          type: 0,
          note: "",
          cityId: "",
          stateId: "",
          patientAddress: ""
        })
        setIsOpenAdd(false)
        //GetTodaysConfirmed()
        navigate(`/checkregister/${mdata.data.id}`)
        toast.open("Opd added successfully.", <IoCheckmarkDoneCircleOutline />, "success", 5000)
      } else {
        toast.open(mdata.result.message, <MdErrorOutline />, "danger", 5000)
      }
      setLodingCrud(false)
      end()
    }).catch(errors => {
      setLodingCrud(false)
      end()
      toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
    })
  }

  return (
    <MasterPage>
      {
        !loding ?
          user ?
            <div className="w-full flex-row md:flex px-2 pb-3 ">
              <div class="w-full md:w-3/12 md:mx-2">

                {user && <User user={user} isBorder={true} borderColor='border-green-300' isBack={true} title={"OPD Centers"} />}

              </div>
              <div class="my-4"></div>

              <div class="flex flex-col space-y-5 w-full md:w-9/12 md:mx-2 ">
                {opdCenters.map((item, index) =>
                  <>
                    <div onClick={() => {
                      if (item.isRegisterOnline == 1) {
                        setCenterName(item.centerName);
                        setIsOpenAdd(!isOpenAdd);
                        setCenterId(item.id);
                        setSelectedCenter(item)
                      }
                    }} class="w-full md:mx-2 cursor-pointer">
                      <Card isBorder={true} borderColor='border-sky-300' title={item.centerName}>
                        <div class="text-gray-700">
                          <div class="grid text-sm">
                            {item.isRegisterOnline == 0 ?
                              <>
                              </>
                              :
                              item.opdType == 0 ?
                                <div class="flex">
                                  <div class="w-4/12 px-4 py-2 font-semibold">Register Appointment</div>
                                  <div class="w-8/12 px-4 py-2">{moment(item.startPuttingAppointment).format("LT")} - {moment(item.endPuttingAppointment).format("LT")}</div>
                                </div>
                                :
                                <>
                                  <div class="flex">
                                    <div class="w-4/12 px-4 py-2 font-semibold">Register Appointment </div>
                                    <div class="w-8/12 px-4 py-2">{moment(TODAYS_DATE).format("DD/MM/YYYY")} to {moment(TODAYS_DATE.setDate(TODAYS_DATE.getDate() + parseInt(item.byDaysCount))).format("DD/MM/YYYY")}</div>
                                  </div>
                                </>
                            }
                            <div class="flex">
                              <div class="w-4/12 px-4 py-2 font-semibold">OPD Timing</div>
                              <div class="w-8/12 px-4 py-2">{moment(item.opdStartTime).format("LT")} - {moment(item.opdEndTime).format("LT")}</div>
                            </div>
                            <div class="flex">
                              <div class="w-4/12 px-4 py-2 font-semibold">Opens</div>
                              <div class="w-8/12 px-4 py-2 space-x-1">
                                {
                                  item.opdDays.split(',').map((item, index) =>
                                    <>
                                      {index != 0 && " ,"}{GetEOpdDaysName(item.trim())}
                                    </>
                                  )
                                }</div>
                            </div>
                            <div class="flex">
                              <div class="w-4/12 px-4 py-2 font-semibold">Address</div>
                              <div class="w-8/12 px-4 py-2">{item.address},{item.city.name}, {item.city.state.name}, Phone {item.phone}</div>
                            </div>

                            <div class="flex">
                              <div class="w-4/12 px-4 py-2 font-semibold">Doctor's Status</div>
                              <div class="w-8/12 px-4 py-2"><StatusContainer bg={EDoctorStatusBg(item.doctorStatus)} text={GetEDoctorStatusName(item.doctorStatus)} /></div>
                            </div>
                            {item.user.isOnLeave === 0 ?
                              <>
                              </>
                              :
                              <>
                                <div class="flex">
                                  <div class="w-4/12 px-4 py-2 font-semibold">On Leave</div>
                                  <div class="w-8/12 px-4 py-2"><StatusContainer bg={`${item.user.isOnLeave == 0 ? "bg-green-400" : "bg-red-400"}`} text={GetEBoolName(item.user.isOnLeave)} /></div>
                                </div>
                                {item.user.leaveNote && <div class="flex">
                                  <div class="w-4/12 px-4 py-2 font-semibold">Leave Note</div>
                                  <div class="w-8/12 px-4 py-2">{item.user.leaveNote}</div>
                                </div>}
                              </>
                            }

                            {item.details && <div class="flex">
                              <div class="w-4/12 px-4 py-2 font-semibold">Detail</div>
                              <div class="w-8/12 px-4 py-2">{item.details}</div>
                            </div>}
                            {item.isRegisterOnline == 0 ?
                              <>
                              </>
                              :
                              <div className="flex justify-end">
                                <button
                                  type="button"
                                  title="Register"
                                  onClick={() => {
                                    setCenterName(item.centerName);
                                    setIsOpenAdd(!isOpenAdd);
                                    setCenterId(item.id);
                                  }}
                                  className="flex items-center gap-1 px-3 py-2 text-white bg-sky-500 rounded-lg shadow-md hover:bg-sky-600 focus:outline-none focus:ring-2 focus:ring-sky-400 active:bg-sky-700 transition-all duration-200"
                                >
                                  <IoMdAdd className="text-lg" />
                                  <span className="text-sm font-medium">Create Appointment</span>
                                </button>
                              </div>
                            }

                          </div>
                        </div>
                      </Card>
                    </div>
                  </>
                )}
              </div>
            </div>
            :
            <div className="w-full flex-row md:flex px-2 pb-3 ">
              <div class="w-full md:mx-2">
                <Card title={"Not Found"} isBorder={true} isBack={true} borderColor='border-green-300'>
                  <div className="w-full text-3xl text-gray-700 text-center py-20">
                    Doctor has no OPD center, please contact doctor, or search again.
                  </div>
                </Card>
              </div>
            </div>
          :
          <div className="w-full flex-row md:flex px-2 pb-3 ">
            <div class="w-full md:mx-2">
              <LoadingContainer text={"Getting doctor's profile"} />
            </div>
          </div>
      }
      {selectedCenter && <AddOpdOnline title={`Create Appointment for ${centerName}`} centerData={selectedCenter} addOpdOnline={addOpdOnline} isOpen={isOpenAdd} setIsOpen={setIsOpenAdd} loding={lodingCrud} centerId={centerId} />}

    </MasterPage >
  );
}
